
import { Component, Prop, Vue } from "vue-property-decorator";
import methodList from "@/config/Common";
declare global {
  interface Window {
    _satellite: any;
  }
}
@Component
export default class BannerButton extends Vue {
  @Prop() private banner!: any;
  @Prop() private methods!: any;

  private methodList = methodList;

  public mounted() {
    this.initOApp();
  }

  private getImg =  (img) => {
    const host = window.location.host;
    return /localhost/.test(host) ? `/forLocal/img/${img}` : `/rsc/contrib/image/celebrus/${img}`;
  }

  private initOApp() {
    if (this.banner.cta1Webcallback) {
      const self = this;
      /* global OApp */
      const initializeOApp = setInterval(() => {
        if ((window as any).OApp) {
          (window as any).OApp.runLoading();
          clearInterval(initializeOApp);
          document
            .getElementById(self.getWebcallbackType1())
            .addEventListener("click", self.onCta1Click);
        }
      }, 200);
    } else if (this.banner.cta2Webcallback) {
      const self = this;
      /* global OApp */
      const initializeOApp = setInterval(() => {
        if ((window as any).OApp) {
          (window as any).OApp.runLoading();
          clearInterval(initializeOApp);
          document
            .getElementById(self.getWebcallbackType2())
            .addEventListener("click", self.onCta2Click);
        }
      }, 200);
    }
  }

  private getWebcallbackType1() {
    if (this.banner.cta1Webcallback) {
      return `nextcallback_${this.banner.cta1Webcallback}`;
    } else {
      return "";
    }
  }

  private getWebcallbackType2() {
    if (this.banner.cta2Webcallback) {
      return `nextcallback_${this.banner.cta2Webcallback}`;
    } else {
      return "";
    }
  }

  private async onCta1Click() {
    if (this.banner.cta1URL) {
      if (this.banner.cta1URL !== "https://helloiz" && this.banner.cta1URL !== "https://cookieconsent") {
        window.open(this.banner.cta1URL, this.getTargetCta("cta1"));
      } else if (this.banner.cta1URL !== "https://cookieconsent") {
        if (!(window as any).MyObjContact) {
          (window as any).MyObjContact = new (window as any).Contact();
        } else {
          (window as any).MyObjContact.nextStep();
        }
      }
    } else {
      if (this.banner.cta1Webcallback) {
        setTimeout(() => {
          (window as any).Popin.init();
          // @ts-ignore
          Popin.showPopin($("#callbackpopin"));
        }, 1000);
      }
    }
    // Keep banner or delete banner after click
    if (this.banner.cta1KeepBanner === "true") {
      this.getCta1CustomReponse();
    } else {
      this.getCta1CustomReponse();
      this.getEmptyBanner();
    }
    if (!!window.hasOwnProperty("_satellite")) {
      window._satellite.track("DCRMBannerCTA", {  label: this.banner.cta1Text,
                                                  placement: this.banner.location,
                                                  campaign: this.banner.messageId,
                                                  url: this.banner.cta1URL});
    }
  }

  private getCta1CustomReponse() {
    if (this.banner.cta1Reponse) {
      this.banner.celebrusHelper.custom(this.banner.cta1Reponse);
    } else {
      this.banner.celebrusHelper.accepted();
    }
  }

  private getCta2CustomReponse() {
    if (this.banner.cta2Reponse) {
      this.banner.celebrusHelper.custom(this.banner.cta2Reponse);
    } else {
      this.banner.celebrusHelper.refused();
    }
  }

  private getTargetCta(cta) {
    switch (cta) {
      case "cta1":
        return this.banner.cta1Target === "true" ? "_blank" : "_self";
        break;
      case "cta2":
        return this.banner.cta2Target === "true" ? "_blank" : "_self";
        break;
    }
  }

  private getEmptyBanner() {
    window.dispatchEvent(
      new CustomEvent(`rtim-banner:${this.banner.location}`, {
        detail: {
          content: {
            emplacement: this.banner.location,
            nom_gabarit: "Gab20",
          },
          placement: {
            id: this.banner.location,
            size: "1260x630",
            zone: "udc-top",
          },
        },
      })
    );
  }

  private async onCta2Click() {
    if (this.banner.cta2URL) {
      if (this.banner.cta2URL !== "https://helloiz" && this.banner.cta2URL !== "https://cookieconsent") {
        window.open(this.banner.cta2URL, this.getTargetCta("cta2"));
      } else if (this.banner.cta2URL !== "https://cookieconsent") {
        if (!(window as any).MyObjContact) {
          (window as any).MyObjContact = new (window as any).Contact();
        } else {
          (window as any).MyObjContact.nextStep();
        }
      }
    } else {
      if (this.banner.cta2Webcallback) {
        setTimeout(() => {
          (window as any).Popin.init();
          // @ts-ignore
          Popin.showPopin($("#callbackpopin"));
        }, 1000);
      }
    }
    // Keep banner or delete banner after click
    if (this.banner.cta2KeepBanner === "true") {
      this.getCta2CustomReponse();
    } else {
      this.getCta2CustomReponse();
      this.getEmptyBanner();
    }
    if (!!window.hasOwnProperty("_satellite")) {
      window._satellite.track("DCRMBannerCTA", {  label: this.banner.cta2Text,
                                                  placement: this.banner.location,
                                                  campaign: this.banner.messageId,
                                                  url: this.banner.cta2URL});
    }
  }

  private isCta1SpecificUrl() {
    if (this.banner.cta1URL === "https://helloiz") {
      return "iadvize-launcher";
    } else if (this.banner.cta1URL === "https://cookieconsent") {
      return "cookiesdisplayparameters";
    }
  }

  private isCta2SpecificUrl() {
    if (this.banner.cta2URL === "https://helloiz") {
      return "iadvize-launcher";
    } else if (this.banner.cta2URL === "https://cookieconsent") {
      return "cookiesdisplayparameters";
    }
  }

  private getCta1AriaLabel() {
    if (this.banner.cta1AriaLabel) {
       return this.banner.cta1AriaLabel;
    }
  }
  private getCta2AriaLabel() {
    if (this.banner.cta2AriaLabel) {
       return this.banner.cta2AriaLabel;
    }
  }

}
